






































































































































































































import { Component } from 'vue-property-decorator';
import VueI18n from 'vue-i18n';
import SettingMixin from '@/components/ViewComponent/Setting/setting.mixin';

@Component<Profile>({})
export default class Profile extends SettingMixin {
  get genderOptions(): { text: VueI18n.TranslateResult; value: boolean }[] {
    return [
      {
        text: this.$t('common.male'),
        value: true,
      },
      {
        text: this.$t('common.female'),
        value: false,
      },
    ];
  }
}
